import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { SelectItem } from "primeng/components/common/selectitem";
import { DropDownSocialLink, EditRewardModel, Reward, RewardPlansModel, RewardSocialLinksModel, TagRewardModel } from '../../../models/inModels/Rewards';
import { RewardsService } from '../../../services/rewards/rewards.service';
import { StorageService } from '../../../services/system/storage.service';
import { SubscriptionPlanService } from "../../../services/subscription.service";

@Component({
	selector: 'app-rewards-edit',
	templateUrl: './rewards-edit.component.html',
	styleUrls: ['./rewards-edit.component.css']
})
export class RewardsEditComponent implements OnInit {
	id;
	model: EditRewardModel;
	loading = false;
	error: Message[];
	uploading = false;
	rewards;
	tags = false;
	reward: Reward;
	selectedReward: Reward;
	tag: TagRewardModel;
	planModel: RewardPlansModel;
	plans: SelectItem[];
	selectedPlan;
	RewardTypeId: SelectItem[];
	selectedRewardType;
	socialLinks: DropDownSocialLink[] = [];
	rewardSocialCount: number
	links = { RewardSocialLinks: [] as { label: string; url: string }[] };
	socialPlatforms = [
		{ id: 6, name: 'LinkedIn', url: '' },
		{ id: 7, name: 'Facebook', url: '' },
		{ id: 8, name: 'Instagram', url: '' },
		{ id: 9, name: 'Lemi', url: '' },
		{ id: 10, name: 'Twitter', url: '' },
	  ];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: RewardsService,
		private storageService: StorageService,
		private subscriptionService: SubscriptionPlanService) {
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit() {
		this.getReward();
		this.tag = new TagRewardModel();
		this.loadSocialLinks();
	}

	getReward() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.reward = result;
				this.model = new EditRewardModel(result);
				this.selectedRewardType = { value: result.RewardTypeId, label: result.RewardType }
				this.planModel = new RewardPlansModel();
				this.planModel.Id = result.Id;
				this.loading = false;
				this.rewardSocialCount = this.model.RewardSocialLinks.length;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	goBack(): void {
		this.router.navigate(['/rewards']);
	}

	save() {
		const rewardSocialLinks: RewardSocialLinksModel[] = this.socialPlatforms
        .filter((social) => social.url.trim() !== '')
        .map((social) => ({
            Id: social.id,
            Title: social.name, 
            SocialId: social.id,
            Url: social.url,
        }));
		this.model.RewardSocialLinks = rewardSocialLinks;
		this.loading = true;	
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditRewardModel(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Reward saved" });
				console.log("result",result);
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.LogoId = result.PublicId;
		this.loading = false;
	}

	handleBackgroundImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.BackgroundPictureId = result.PublicId;
		this.loading = false;
	}
	handleAboutImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.SubBodyImageId = result.PublicId;
		this.loading = false;
	}

	handleProductImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.ProductPreviewId = result.PublicId;
		this.loading = false;
	}
	handleCoverImage(event): void {
		var result = this.storageService.handleSuccess(event);
		this.model.CoverImageId = result.PublicId;
		this.loading = false;
	}

	handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

	removeImage(): void {
		this.model.LogoId = null;
		this.loading = false;
	}

	removeProductImage(): void {
		this.model.ProductPreviewId = null;
		this.loading = false;
	}
	removeCoverImage(): void {
		this.model.CoverImageId = null;
		this.loading = false;
	}

	removeBackgroundImage() {
		this.model.BackgroundPictureId = null;
		this.loading = false;
	}
	removeAboutImage(){
		this.model.SubBodyImageId = null;
			this.loading = false;
	}


	tagFile(): void {
		this.loading = true;
		this.tag.Id = this.model.Id;
		this.service.tagReward(this.tag).then(
			result => {
				this.model.Tags = this.model.Tags || [];
				this.model.Tags.push({ Id: this.tag.Id, Name: this.tag.Name });
				this.tag.Name = '';
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	viewTags(reward: Reward): void {
		this.selectedReward = reward;
		this.tags = true;
	}

	clearRewards() {
		this.tag.Id = this.model.Id;
		this.service.clearReward(this.tag).then(
			result => {
				this.model.Tags = [];
			}
		);
	}

	initRewardTypeDropDown(event): void {
		this.service.getDropdownList(event).then(
			x => {
				this.rewards = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setRewardType(): void {
		this.model.RewardTypeId = this.selectedRewardType.value;
	}

	initPlanDropDown(event) {
		this.subscriptionService.getDropdown(event).then(
			x => {
				this.plans = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	removePlan(item) {
		console.log(item);
		this.service.removePlan(this.reward.Id, item.Id).then(
			result => {
				this.loading = false;
				this.getReward();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	editPlan(item) {
		this.selectedPlan = { label: item.Name, value: item.Id };
		this.planModel.PlanId = item.Id;
		this.planModel.DiscountPercentage = item.RewardDiscountPercentage;
	}

	setPlans(): void {
		this.planModel.PlanId = this.selectedPlan.value;
		this.loading = true;
		this.service.updatePlan(this.planModel).then(
			result => {
				this.loading = false;
				this.model = new EditRewardModel(result);
				this.selectedPlan = {};
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	loadSocialLinks(): void {
		this.service.getSocialLinks()
		  .then(links => {
			this.socialLinks = links;
			// Initialize RewardSocialLinks with corresponding labels and empty links
			this.links.RewardSocialLinks = this.socialLinks.map(link => ({
			  label: link.label,
			  url: ''
			}));
		  })
		  .catch(error => {
			console.error('Failed to load social links:', error);
		  });
	  }
}



// WEBPACK FOOTER //
// ./src/app/components/rewards/rewards-edit/rewards-edit.component.ts